var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2048,
    height: 2048,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024-.001c565.539 0 1024 458.462 1024 1024 0 565.539-458.462 1024-1024 1024-565.539 0-1024-458.462-1024-1024 0-565.54 458.462-1024 1024-1024z"
  })), /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#b39ddb}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024-.001c565.539 0 1024 458.462 1024 1024 0 565.539-458.462 1024-1024 1024-565.539 0-1024-458.462-1024-1024 0-565.54 458.462-1024 1024-1024z",
    style: {
      fill: "#d1c4e9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_289369160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_3062939041",
    className: "fil1",
    d: "M1584 743.999 2719.88 1879.88v816.67L1584 1560.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_306294024",
    className: "fil1",
    d: "m1584 1560.67 1135.88 1135.88-.12 2.38-.35 2.32-.58 2.24-.78 2.14-.98 2.04-1.17 1.92-1.35 1.8-1.5 1.66-1.66 1.5-1.8 1.35-1.92 1.17-2.04.98-2.14.78-2.24.58-2.32.35-2.38.12L1560.67 1584l2.38-.12 2.32-.35 2.24-.58 2.14-.78 2.04-.99 1.92-1.16 1.8-1.35 1.66-1.5 1.5-1.66 1.35-1.8 1.16-1.92.99-2.04.78-2.14.58-2.24.35-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_306293928",
    className: "fil1",
    d: "m1560.67 1584 1135.88 1135.88H1623.22L487.334 1584z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_306294192",
    className: "fil1",
    d: "M487.334 1584 1623.22 2719.88l-2.39-.12-2.32-.35-2.23-.58-2.15-.78-2.04-.98-1.92-1.17-1.8-1.35L472.491 1578.67l1.796 1.35 1.924 1.16 2.04.99 2.144.78 2.236.58 2.317.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_306294096",
    className: "fil1",
    d: "M1578.67 472.491 2714.55 1608.37l1.35 1.8 1.17 1.92.98 2.04.78 2.15.58 2.23.35 2.32.12 2.39L1584 487.334l-.12-2.386-.35-2.317-.58-2.236-.78-2.144-.99-2.04-1.16-1.924z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_306294216",
    className: "fil1",
    d: "M1584 487.334 2719.88 1623.22v210L1584 697.335z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_306294288",
    className: "fil1",
    d: "M1584 697.335 2719.88 1833.22v46.66L1584 743.999z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_289368800",
    className: "fil1",
    d: "M1584 743.999v816.667c0 12.887-10.448 23.335-23.335 23.335H487.335c-12.887 0-23.335-10.448-23.335-23.335V487.334c0-12.887 10.448-23.335 23.335-23.335h1073.33c12.887 0 23.335 10.448 23.335 23.335v256.665z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1024-.001c565.539 0 1024 458.462 1024 1024 0 565.539-458.462 1024-1024 1024-565.539 0-1024-458.462-1024-1024 0-565.54 458.462-1024 1024-1024z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584 697.335v863.331c0 12.887-10.448 23.335-23.335 23.335H487.335c-12.887 0-23.335-10.448-23.335-23.335V697.335h1120z",
    style: {
      fill: "#8e96a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b838e"
    },
    d: "M1584 697.335v46.664H463.999v-46.664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.334 463.999h1073.33c12.887 0 23.335 10.448 23.335 23.335v210H464v-210C464 474.447 474.447 464 487.334 464z",
    style: {
      fill: "#415065",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.9 1327.33V954h49.373v373.33H1371.9zm-306.92-195.835h96.57c31.9 0 54.586-5.91 67.973-17.82 13.385-11.907 20.079-28.596 20.079-50.153 0-15.646-3.912-29.032-11.822-40.158-7.91-11.126-18.254-18.428-31.205-21.991-8.344-2.173-23.643-3.303-46.068-3.303h-95.527v133.425zm-49.373 195.835V954h140.814c24.772 0 43.722 1.218 56.76 3.565 18.34 3.04 33.726 8.865 46.156 17.47 12.341 8.519 22.338 20.601 29.9 35.986 7.564 15.472 11.3 32.422 11.3 50.937 0 31.726-10.083 58.672-30.248 80.663-20.253 21.905-56.761 32.943-109.523 32.943h-95.787v151.766h-49.373zM734.415 1174H861.06l-39.028-103.351c-11.822-31.378-20.688-57.194-26.426-77.447-4.78 23.99-11.472 47.72-20.165 71.363L734.413 1174zm-107.695 153.33L770.139 954h53.196l152.81 373.33H919.82l-43.549-113.085H720.16l-40.94 113.085h-52.5z",
    style: {
      fill: "#ffc107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef5350",
      fillRule: "nonzero"
    },
    d: "M1397.44 532.809v93.332h93.33v-93.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffab40",
      fillRule: "nonzero"
    },
    d: "M1070.55 626.141h93.34v-93.332h-93.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7cb342",
      fillRule: "nonzero"
    },
    d: "M1233.76 532.809v93.332h93.33v-93.332z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.7723d32c898d3fe310635381eb76d235.svg";
export { ForwardRef as ReactComponent };